import { AJOUTE_CLIENT, SUPRIMER_CLIENT } from '../types/typeClient';

export const AjouteClient = (client) => {
    return {
        type: AJOUTE_CLIENT,
        payload: client
    }
}

export const suprimerClient = () => {
    return {
        type: SUPRIMER_CLIENT,
        payload: []
    }
}